<template>
  <div>
    <div
      id="main-map"
      :class="{ expanded: this.mapExpanded, 'mapboxgl-map': true }"
    >
    </div>
  </div>
</template>
<script>
import mapboxgl from "mapbox-gl";
import "@mapbox/mapbox-gl-geocoder/dist/mapbox-gl-geocoder.css";
import mainConfig from '../config/mainConfig.json'
import styleConfig from '../config/styleConfig.json'
import BasemapControl from "../js/BasemapControl";
import LegendControl from "../js/LegendControl";
import { EventBus } from "../js/DataManagement/EventBus";

export default {
  // eslint-disable-next-line
  name: "Map",
  components: {},
  props: {
    startLocation: {
      center: Array,
      zoom: Number
    },
    showApp: { type: Function }
  },
  data: function () {
    return {
      mapExpanded: false,
    };
  },
  mounted: function () {
    mapboxgl.accessToken = mainConfig.api.keys["mb-key"];
    this.map = new mapboxgl.Map({...mainConfig.mapConfig, ...this.startLocation});
    let map = (this.$.appContext.app.config.globalProperties.$map = this.map);
      window.$map = this.map;

    let self = this;
    EventBus.$on("toggle-panel", (panelExpanded) => {
      self.mapExpanded = !panelExpanded;
      self.$nextTick(() => {
        self.map.resize();
      });
    });

    // Add basemap control and move it to the flex container
    this.map.addControl(new BasemapControl(this), "top-left");
    
    // Wait a moment for the control to be added, then move it
    this.$nextTick(() => {
      setTimeout(() => {
        const basemapElement = document.querySelector('.basemap-control-container');
        const container = document.querySelector('.left-controls-container');
        if (basemapElement && container) {
          container.appendChild(basemapElement);
        }
      }, 100);
    });

    map.addControl(new mapboxgl.ScaleControl(), "bottom-right");
    map.addControl(new mapboxgl.NavigationControl(), "bottom-right");
    map.once("idle", () => {
      this.showApp()
      this.$layerManager.addNativeLandsLayer()
    });

    map.on("mousemove", () => map.getCanvas().style.cursor = "crosshair");
    map.on("mouseout", () => map.getCanvas().style.cursor = "");

    map.on("click", (e) => {
      const features = map.queryRenderedFeatures(e.point, {
        filter: map.getFilter('events-circles')
      });

      if (features.length === 0) {
        self.$store.commit("setSelectedEventId", -1);
        this.$router.replace({path: this.$route.path, query: {}, hash: location.hash})
        if(map.getFilter('events-circles')) {
          self.$layerManager.styleCircleSelection(map.getFilter('events-circles')[2][1])
        } else {
          self.$layerManager.clearCircleFeatureStyling();
        }

        EventBus.$emit("clear-event");
        return;
      }

      const eventFeatures = features
        .filter((f) => f.layer.id === "event-hit-layer")
        .map((f) => f.properties);

      EventBus.$emit("new-panel", eventFeatures); //HC

      this.$store.commit(
        "setSelectedEventId",
        eventFeatures.length === 1 ? eventFeatures[0].id : -1
      );
      if (eventFeatures.length === 1) {
        this.$router.replace({path: this.$route.path, query: {event: eventFeatures[0].id}, hash: location.hash})
        if(!map.getFilter('events-circles')) {
          self.$nextTick(() => {
              self.$layerManager.styleCircleSelection([this.$store.getters.getSelectedEventId]);
          });
        }
      } else{
        this.$router.replace({path: this.$route.path, query: {}, hash: location.hash})
          self.$nextTick(() => {
            if(map.getFilter('events-circles')) {
              self.$layerManager.styleCircleSelection(map.getFilter('events-circles')[2][1])
            } else {
              self.$layerManager.clearCircleFeatureStyling();
            }
          });
      }
    });

    map.on('style.load', () => {
      this.initLayers()
      if(this.$store.getters.getSelectedEventId > 0){
        this.$layerManager.styleCircleSelection([this.$store.getters.getSelectedEventId]);
      }
    });
  },
// In your Map.vue component, replace the debug code with this:
// In your Map.vue component:
// In your Map.vue component:
methods: {
  initLayers() {
    this.$layerManager.addBaserowToMap();
    this.$layerManager.addNativeLandsLayer();

    // Listen for the LayerManager's completion and emit immediately
    EventBus.$on('events-loaded', () => {
      this.emitDataToLegend();
    });

    // Also try multiple times at shorter intervals as backup
    setTimeout(() => this.emitDataToLegend(), 2000);
    setTimeout(() => this.emitDataToLegend(), 4000);
    setTimeout(() => this.emitDataToLegend(), 6000);

    if (!this.legendControl) {
      this.legendControl = new LegendControl(this.$.appContext.app.config.globalProperties);
      this.map.addControl(this.legendControl, "bottom-left");
    }
  },

  emitDataToLegend() {
    const eventsSource = this.map.getSource('events-source');
    if (eventsSource && eventsSource._data && eventsSource._data.features) {
      const data = eventsSource._data.features.map(f => f.properties);
      if (data.length > 0) {
        console.log('Emitting data to legend immediately:', data.length, 'events');
        EventBus.$emit('map-data-updated', data);
        return true; // Successfully emitted
      }
    }
    return false; // No data to emit yet
  }
},
  watch: {},
};
</script>
<style lang="scss" scoped>
#main-map {
  height: calc(100vh - 37px);
  width: 75%;
}
#main-map.expanded {
  width: 100%;
  right: 0px;
}
.expanded {
  .mapboxgl-canvas-container {
    width: 100% !important;
    right: 0 !important;
  }
}
.mapboxgl-ctrl-bottom-right {
  pointer-events: auto;
}
</style>
<style lang="scss">
.mapboxgl-ctrl-top-left {
  top: 0;
  left: 155px;
}
.mapboxgl-ctrl-bottom-left {
  .mapboxgl-ctrl {
    margin: 0;
    width: 160px;
  }
  z-index: 3;
}
.mapboxgl-popup-content {
  overflow-y: scroll;
  max-height: 35vh;
  font-size: 12px;
  width: 125%;
  .hidden {
    display: none;
  }
  .img-caption {
    font-style: italic;
  }
  .popup-title {
    border-bottom: 1px solid black;
    padding-bottom: 8px;
    margin-bottom: 8px;
    font-weight: bold;
  }
}
.img-container {
  width: 100%;
  img {
    max-width: 90%;
    margin: 0 auto;
    display: block;
  }
}
.mapboxgl-ctrl-attrib-inner {
  display: inline-block;
}
.third-party-logo {
  max-height: 40px;
  max-width: 110px;
  padding: 0 5px;
}
.third-party-container {
  transform: translate(-100px, -15px);
}
.mapboxgl-ctrl-bottom-right {
  .mapboxgl-ctrl-attrib-inner {
    a {
      color: #565656;
    }
  }
}
.portrait {
  .mapboxgl-ctrl-bottom-left {
    z-index: 2;
  }
  .mapboxgl-ctrl-top-left {
    display: none;
  }
  .mapboxgl-ctrl-bottom-right {
    display: none;
  }
  .mapboxgl-ctrl-top-right {
    .mapboxgl-ctrl-geocoder {
      display: none;
    }
  }
}
</style>